import { FC } from "react";
import { QESWidget } from "@app/shared/widget/QESWidget";
import { QESWidgetContent } from "@app/shared/widget/QESWidgetContent";
import { QESWidgetFooter } from "@app/shared/widget/QESWidgetFooter";

export const ProjectCardSkeleton: FC = () => (
  <QESWidget
    className="network-portfolio-management-project-card skeleton shimmer"
    data-testid="network-portfolio-management-project-card-skeleton"
  >
    <QESWidgetContent>
      <div className="bone network-portfolio-management-project-card-skeleton__name-bone" />
      <div className="network-portfolio-management-project-card-skeleton__score">
        <div className="bone network-portfolio-management-project-card-skeleton__metric-label-bone" />
        <div className="bone network-portfolio-management-project-card-skeleton__metric-bar-bone" />
      </div>
    </QESWidgetContent>
    <QESWidgetFooter className="network-portfolio-management-project-card-skeleton__footer">
      <div className="bone network-portfolio-management-project-card-skeleton__date-bone" />
      <div className="network-portfolio-management-project-card-skeleton__go-to-project-row">
        <div className="bone network-portfolio-management-project-card-skeleton__link-bone" />
      </div>
    </QESWidgetFooter>
  </QESWidget>
);
